export default {
  SET_ACURACIA_POR_UNIDADE(state, payload) {
    state.acuraciaPorUnidade = payload;
  },
  SET_ACURACIA_POR_CLIENTE(state, payload) {
    state.acuraciaPorCliente = payload;
  },
  SET_ACURACIA_MENSAL(state, payload) {
    state.acuraciaMensal = payload;
  },
  SET_ACURACIA_QUANTIDADE_ITEM_CLIENTE(state, payload) {
    state.acuraciaQuantidadeItemCliente = payload;
  },
  SET_ACURACIA_QUANTIDADE_INVENTARIADA_PRODUTO(state, payload) {
    state.acuraciaQuantidadeInventariadaProduto = payload;
  },
  SET_ACURACIA_INFORMACOES_ESTOQUE(state, payload) {
    state.informacoesEstoque = payload;
  },
};
